import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class SelfCurbside extends AbstractProductType {

  name = 'self_curbside'
  title = 'Self Curbside'

  curbside = true

  format = ProductTypeFormat.Uncovered

}
